var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('b-tabs',[_c('b-tab',{attrs:{"title":"Submissions","active":""}},[_c('ProjectSubmissionTable',{attrs:{"project":_vm.project}})],1),_c('b-tab',{attrs:{"title":"Samples"}},[_c('ProjectSampleTable',{attrs:{"project":_vm.project}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }